import { useSearchParams } from 'react-router-dom';
import { DocumentWorkspace } from '@widgets/document-workspace';
import { hasSapInvoiceIndexId, SapInvoiceDocumentsPage } from '@features/sap-invoice';

const HomePage: React.FC = () => {
  const [searchParams] = useSearchParams();

  if (hasSapInvoiceIndexId(searchParams)) {
    return <SapInvoiceDocumentsPage />;
  }

  return <DocumentWorkspace />;
};

export default HomePage;
